<template>
  <div id="wareHouseChart" class="chart"></div>
</template>
<script>
import { statisticsApi } from "@/api"
export default {
  name: "wareHousePie",
  data() {
    return {
      myChart: null,
      chartData: []
    }
  },
  created() {
    this.getWareHouseGoodsCount()
  },
  methods: {
    resize() {
      this.myChart&&this.myChart.resize()
    },
    getWareHouseGoodsCount() {
      statisticsApi.getWareHouseGoodsCount().then(data => {
        this.chartData = data
        this.drawChars()
      })
    },
    drawChars() {
      var chartDom = document.getElementById("wareHouseChart")
      this.myChart = this.$echarts.init(chartDom)
      var option

      // 计算总和
      const total = this.chartData.reduce((acc, item) => acc + item.value, 0)

      option = {
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: {c}件"
          // position: function(point, params, dom, rect, size) {
          //   // 调整 tooltip 的位置，避免被其他元素挡住
          //   return [point[0] + 10, point[1] + 10]
          // },
          // backgroundColor: "rgba(0, 0, 0, 0.7)", // 调整背景颜色
          // textStyle: {
          //   color: "#fff" // 调整文字颜色
          // }
        },
        legend: {
          bottom: "5%",
          left: "center",
          formatter: (name) => {
            const item = this.chartData.find(item => item.name === name)
            const percentage = total === 0 ? 0 : ((item.value / total) * 100).toFixed(2)
            return `${name} ${percentage}%`
          }
        },
        series: [
          {
            name: "分项占比",
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "40%"], // 调整饼状图的位置，使其向上移动
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: true // 显示标签
              // formatter: "{b}: {c} ({d}%)"// 标签显示占比
            },
            emphasis: {
              scale: false, // 禁用放大效果
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true// 显示引导线
            },
            data: this.chartData
          }
        ]
      }

      option && this.myChart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
